import { apiSlice } from "./apiSlice";
import { ASSOCIATES_URL } from "../constants";

const associatesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registerOwner: builder.mutation({
      query: (data) => ({
        url: `${ASSOCIATES_URL}/createOwner`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    sendOtp: builder.mutation({
      query: (data) => ({
        url: `${ASSOCIATES_URL}/sendOtp/${data.associateId}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: `${ASSOCIATES_URL}/resetPassword/${data.associateId}`,
        method: "PUT",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useRegisterOwnerMutation,
  useResetPasswordMutation,
  useSendOtpMutation,
} = associatesApiSlice;
